export default "__VITE_ASSET__DT8VNUzu__"